import React from 'react';
import createStore from './store/learnerDashboardStore';
import { RootProvider } from '@everfi/reactifi/src/react-on-rails/RootProvider';
import LearnerDashboardContainer from './containers/LearnerDashboardContainer';
import { HeapTracking } from '../../components/HeapTracking';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export default (props, _railsContext) => {
  const { heapId, reCaptchaKey, user } = props;
  const store = createStore(props || {});
  return () => {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
        <HeapTracking id={heapId} user={user} trackScrollDepth={true} />
        <RootProvider store={store}>
          <LearnerDashboardContainer
            {...props}
            contentServiceUrl={_railsContext.content_service_url}
            certificateServiceUrl={_railsContext.certificate_service_url}
            adminifiUrl={_railsContext.adminifi_url}
            jwt={_railsContext.jwt}
            facebookAppId={_railsContext.facebook_app_id}
          />
        </RootProvider>
      </GoogleReCaptchaProvider>
    );
  };
};
